import { CircularProgress } from '@material-ui/core';
import { chain } from 'lodash';
import React, { useEffect, useState } from 'react';
import VoxelDataTable from '../../../../components/voxel/DataTable/VoxelDataTable';
import VoxelDataTableBody from '../../../../components/voxel/DataTable/VoxelDataTableBody';
import { MenuItem } from '../../../../components/voxel/Menu/VoxelMenu';
import { usePopoverContext } from '../../../../components/voxel/Popover/PopoverLogic';
import VoxelUnderlinedTabs from '../../../../components/voxel/Tabs/VoxelUnderlinedTabs';
import VoxelText from '../../../../components/voxel/Text/VoxelText';
import { projectsApiService } from '../../../../graphql/projects/projectsApiService';
import ProjectStatusKeywordRequestRow from './ProjectStatusKeywordRequestRow';

export interface ProjectStatusKeywordRequestsProps {
  projectId: number;
  setDeleteRequestId: React.Dispatch<React.SetStateAction<number>>;
}

const menuItems: MenuItem[] = [
  { id: 'all', name: 'All searches' },
  { id: 'active', name: 'Active or failed' },
];

export const ProjectStatusKeywordRequests: React.FC<ProjectStatusKeywordRequestsProps> = ({
  projectId,
  setDeleteRequestId,
}) => {
  // Google ads requests
  const popoverContext = usePopoverContext();
  const options = popoverContext.open ? { pollInterval: 5000, skip: false } : { skip: true };
  const googleAdsQuery = projectsApiService.queries.googleAds.useGetGoogleAdsRequests(
    { projectId: projectId },
    popoverContext.open ? { pollInterval: 5000, skip: false } : { skip: true }
  );

  // Get combo data
  const combosQuery = projectsApiService.queries.googleAds.useGetComboRequests(
    { projectId: projectId },
    options
  );

  const [shownSearches, setShownSearches] = useState<string>('all');
  const hasActiveCalls = googleAdsQuery.result?.analyzedRequests?.some(
    (ar) => ar.failedCalls + ar.queuedCalls + ar.processingCalls > 0
  );
  useEffect(() => hasActiveCalls && setShownSearches('active'), [hasActiveCalls]);

  if (
    (!googleAdsQuery.result?.analyzedRequests.length || !combosQuery?.result) &&
    (googleAdsQuery.query.loading || combosQuery.query.loading)
  ) {
    return <CircularProgress />;
  }

  if (!googleAdsQuery?.result.analyzedRequests.length) return null;

  const orderedFilteredRequests = chain(googleAdsQuery?.result.analyzedRequests)
    ?.orderBy([(r) => r.request.createdTime, 'desc'])
    .filter(
      (r) =>
        shownSearches === 'all' ||
        (shownSearches === 'active' && r.queuedCalls + r.processingCalls + r.failedCalls > 0)
    )
    .filter((r) => !r.request.duplicateCheck)
    .value();

  return (
    <>
      <div />
      <div />
      <VoxelUnderlinedTabs
        size='xs'
        menuListItems={menuItems}
        selectedId={shownSearches}
        setSelectedId={setShownSearches}

      />
      <div className="max-h-[400px] w-full overflow-y-scroll">
        {!orderedFilteredRequests?.length && (
          <VoxelText>
            {shownSearches === 'active' && 'No active searches'}
            {shownSearches === 'all' && 'No searches found'}
          </VoxelText>
        )}
        <VoxelDataTable className="w-full">
          <VoxelDataTableBody>
            {orderedFilteredRequests.map((item, index) => (
              <ProjectStatusKeywordRequestRow
                index={index}
                key={item.request.id}
                requestAnalysis={item}
                isCombo={combosQuery?.result?.some(
                  (cr) => cr.googleAdsRequestId === item.request.id
                )}
                setDeleteRequestId={setDeleteRequestId}
              />
            ))}
          </VoxelDataTableBody>
        </VoxelDataTable>
      </div>
    </>
  );
};

export default ProjectStatusKeywordRequests;
